import * as React from "react";
import { conference } from "@/api";
import MeetItem from "./MeetItem";
import styled from "styled-components";
import { Input, message, Modal } from "antd";
import { ConferenceInterface } from "@/types";
import AppointPreview from "../AppointmentMeeting/preview";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 12px 12px 0;
  margin-bottom: 10px;
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #999;
    height: 30px;
  }
  .main {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    /* padding: 5px 10px; */
    border: 1px solid #eee;
    border-radius: 3px;
  }
  .footer {
    height: 50px;
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
    width: 100%;
    .cancel {
      margin-left: 70px;
    }
  }
`;

const HistoryMeeting: React.FunctionComponent = () => {
  const [records, setRecords] = React.useState([]);
  const [viewConf, setViewConf] = React.useState<ConferenceInterface>(null);

  const getMeetings = async () => {
    const params = {
      pageNum: 0,
      pageSize: 100,
      param: {},
    };
    const ret = (await conference.historyDetail(params)) || {};
    setRecords(ret.records || []);
  };

  React.useEffect(() => {
    getMeetings();
  }, []);

  const onItemOperation = (conferenceNo: string, operation: string) => {
    const meeting = records.find((item) => item.conferenceNo === conferenceNo);
    if (operation === "delete") {
      Modal.confirm({
        title: "删除",
        content: "确定要删除该会议？" +conferenceNo,
        onOk: () => deleteConference(meeting),
        okText: "确定",
        cancelText: "取消",
      });
    }
    if (operation === "view") setViewConf(meeting as ConferenceInterface);
  };

  const deleteConference = async (conf: any) => {
    const { conferenceNo } = conf;
    await conference.conferenceRoom(conferenceNo);
    console.log("delete conference!!!!", conferenceNo);
    message.success("会议已删除");
    getMeetings();
  };

  const [searchTxt, setSearchTxt] = React.useState<string>("");
  const txtChangehandler = (v: React.ChangeEvent<HTMLInputElement>) => {
    const txt = v.target.value;
    setSearchTxt(txt);
  };

  const retRecords = React.useMemo<Array<any>>(() => {
    return searchTxt
      ? records.filter(
          (item) =>
            item.title.indexOf(searchTxt) >= 0 ||
            `${item.conferenceNo}`.indexOf(searchTxt) >= 0
        )
      : records;
  }, [records, searchTxt]);

  return (
    <Container>
      <div className="header">
        <span>历史会议</span>
      </div>
      <div className="h30 mt10 mb10 wp100">
        <Input type="text" onChange={txtChangehandler} />
      </div>
      <AppointPreview
        conference={viewConf}
        onClose={() => setViewConf(null)}
        onDelete={onItemOperation}
      ></AppointPreview>
      <div className="main">
        {retRecords.map((x) => (
          <MeetItem
            key={x.conferenceNo}
            item={x}
            onOperation={onItemOperation}
          />
        ))}
      </div>
    </Container>
  );
};

export default HistoryMeeting;
